import React from 'react'
import { Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

type FairPriceNotificationProps = {
  minValue: number
  maxValue: number
}

export function FairPriceNotification({ minValue, maxValue }: FairPriceNotificationProps) {
  const { t, i18n } = useTranslation()

  return (
    <Notification
      type='success'
      size='medium'
      variant='flat'
      title=''
      message={t('wizard.screen.basicInfo.price.recommendedNotification.success', {
        minValue: minValue.toLocaleString(i18n.language),
        maxValue: maxValue.toLocaleString(i18n.language),
      })}
    />
  )
}
